import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-loader',
  templateUrl: './page-loader.component.html',
  styleUrls: ['./page-loader.component.css']
})

export class PageLoaderComponent implements OnInit {

  @Input() loadingType: 'main' | 'content' | 'surveyBuilder' = 'main';
  
  constructor() { }

  ngOnInit() {
  }

}
